import {useSignal} from '@preact/signals-react'
import {useSignals} from '@preact/signals-react/runtime'
import {Button} from 'primereact/button'
import {TabPanel, TabView} from 'primereact/tabview'
import {useMemo} from 'react'
import {useHistory, useParams} from 'react-router-dom'
import TranslateUtils from '../../i18n/TranslateUtils'
import {useQueryParams} from '../../utils/NavigatorUtils'
import useWindowSize from '../../utils/useWindowSize'
import {useAuth} from '../authentication/AuthProvider'
import {removeClientId, setClientId} from '../authentication/AuthUtils'
import FlexBox from '../layout/FlexBox'
import PageContentWrapper from '../layout/PageContentWrapper'
import RoleManagement from '../role/RoleManagement'
import ClientConfiguration from './ClientConfiguration'
import ClientInformation from './ClientInformation'
import {useDetailClient} from './query-keys/ClientQueryManager'

const queryClientInformationKey = 'clientInformation'
const queryRoleManagementKey = 'roleManagement'
const queryWatchConfigurationKey = 'watchConfiguration'

const ClientDetailPage = () => {
    useSignals()

    const {user} = useAuth()
    //#region Translate
    const {translateCommons} = TranslateUtils()
    //#endregion

    //#region Param

    const query = useQueryParams()
    const {id: idString} = useParams()
    const id = useMemo(() => {
        const parsedId = !!idString ? parseInt(idString) : null

        setClientId(parsedId)

        return parsedId
    }, [idString])

    const {data, isFetched} = useDetailClient(user?.id, id, !!user?.id && !!id)

    //#endregion

    //#region Import
    const width = useWindowSize()
    const history = useHistory()
    //#endregion

    //#region Memo
    const getCurrentTabViewIndex = useMemo(() => {
        if (query && !!query?.get('tv')) {
            switch (query.get('tv')) {
                case queryClientInformationKey:
                    return 0
                case queryRoleManagementKey:
                    return 1
                case queryWatchConfigurationKey:
                    return 2
                default:
                    return 0
            }
        }
    }, [query])
    //#endregion

    //#region State
    const currentTabView = useSignal(
        query?.get('tv') ? getCurrentTabViewIndex : 0,
    )
    //#endregion

    //#region Handle Function
    const handleOnchange = e => {
        currentTabView.value = e.index
        history.push(
            `/clients/${id}?tv=${
                e.index === 0
                    ? queryClientInformationKey
                    : e.index === 1
                    ? queryRoleManagementKey
                    : e.index === 2
                    ? queryWatchConfigurationKey
                    : ''
            }`,
        )
    }
    //#endregion

    return (
        <PageContentWrapper>
            <FlexBox>
                <div className="col-12">
                    <TabView
                        activeIndex={currentTabView.value}
                        onTabChange={e => handleOnchange(e)}
                        className="text-lg">
                        <TabPanel header={translateCommons('Information')}>
                            <ClientInformation data={data} />
                        </TabPanel>
                        <TabPanel
                            className="p-0"
                            header={translateCommons('Roles')}>
                            <RoleManagement />
                        </TabPanel>
                        <TabPanel
                            className="p-0"
                            header={translateCommons('Configuration')}>
                            <ClientConfiguration data={data} />
                        </TabPanel>
                        <TabPanel
                            className="p-0"
                            style={{position: 'absolute', right: 10}}
                            headerTemplate={
                                <Button
                                    icon="pi pi-arrow-left"
                                    label={
                                        width <= 991
                                            ? ''
                                            : translateCommons(
                                                  'BACK TO CLIENT LIST',
                                              )
                                    }
                                    onClick={() => {
                                        removeClientId()
                                        history.push('/')
                                    }}></Button>
                            }></TabPanel>
                    </TabView>
                </div>
            </FlexBox>
        </PageContentWrapper>
    )
}

export default ClientDetailPage
